import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

import { BasePage } from '../base.page';

@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  styleUrls: ['./about-us.component.scss']
})
export class AboutUsComponent extends BasePage implements OnInit {

  constructor(protected route: ActivatedRoute, protected translate: TranslateService) {
    super(route, translate);
  }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/about-us/about-us.component.ts